import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../utils/date";
import { useGetProductGroupUploadJobsQuery } from "../../../api/product/productsApi";
import { ProductGroupUploadJob } from "../../../api/product/ProductGroupUploadJob";
import dayjs from "dayjs";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "ProcessedStartedAt",
    key: "ProcessedStartedAt",
    render: (v: string) => v ? dayjs(v).format("DD-MMM-YYYY HH:mm:ss") : "-"
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? dayjs(v).format("DD-MMM-YYYY HH:mm:ss") : "-"
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "IngestedRows",
    key: "IngestedRows"
  },
  // {
  //   title: "Error Rows",
  //   dataIndex: "ErrorRows",
  //   key: "ErrorRows"
  // },
  {
    title: "Error Count",
    dataIndex: "Errors",
    key: "Errors",
    render: (v?: string[]) => v ? v.length : "-"
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: ProductGroupUploadJob) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null || obj.Errors.length === 0}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetProductGroupUploadJobsQuery();

  const sData = data?.toSorted((a, b) =>
    b.ProcessedStartedAt.localeCompare(a.ProcessedStartedAt));
  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
      loading={isFetching}
      dataSource={sData}
      columns={columns}
    />
    </>
  )
}
